import { Container, Header, SpaceBetween, Alert } from '@cloudscape-design/components'
import { useAmplifyAuth } from '../../../providers/AmplifyAuthProvider'
import UserManager from '../components/UserManager'

export default function AdminPage() {
  const { user } = useAmplifyAuth()

  // Check if user has admin/manager permissions
  if (!user || !['admin', 'manager'].includes(user.role)) {
    return (
      <Container>
        <Alert
          statusIconAriaLabel="Error"
          type="error"
          header="Access Denied"
        >
          You don't have permission to access this page. Only administrators and managers can view this content.
        </Alert>
      </Container>
    )
  }

  return (
    <SpaceBetween direction="vertical" size="l">
      <Container
        header={
          <Header
            variant="h1"
            description="Manage users, roles, and system configuration for your organization"
          >
            Administration
          </Header>
        }
      >
        <UserManager />
      </Container>
    </SpaceBetween>
  )
}